import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import LocalCellularTroubleshootingWizardBlockData from '../../../Models/Content/LocalCellularTroubleshootingWizardBlockData';
import LocalCellularTroubleshootingWizard from './LocalCellularTroubleshootingWizardBlock';

export default class LocalCellularTroubleshootingWizardBlock extends EpiComponent<LocalCellularTroubleshootingWizardBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <LocalCellularTroubleshootingWizard context={this.getContext()} iContent={this.props.data}/>;
  }
}
